<template>
    <div class="item-wrapper" >
        <div class="label-wrapper">
            <div class="trail" v-if="trail">试看</div>
            <template v-else>
                <div class="review" v-if="courseType == 2">回放</div>
                <div class="preview" v-if="courseType == 0">直播</div>
                <div class="live" v-if="courseType == 1">
                    <span class="first"></span><span class="second"></span><span class="third"></span>直播</div>
            </template>
        </div>
        <div class="title">
            {{title}}
        </div>
        <div class="status">
            <div v-if="trail">
                可试看
            </div>
            <template v-else >
                <img src="~@/assets/lock.png" alt="" v-if="!hasAuth">
                <!-- <CircleProgress v-else :playtime="playtime" :duration="duration"></CircleProgress> -->
            </template>
        </div>
    </div>
</template>

<script>
    // import CircleProgress from './Circle'
    const courseTypeMap = {
        PREVIEW: 0,
        LIVE: 1, //直播
        REVIEW: 2, //回放
    }
    export default {
        // components: {
            // CircleProgress
        // },
        props: {
            courseType: { 
                type: Number,
                default: courseTypeMap.LIVE
            },
            hasAuth: {
                type: Boolean,
                default: false
            },
            title: {
                type: String,
                default: '关键点位和形态套利战法'
            },
            trail: {
                type: Boolean,
                default: false
            },
            playtime: {
                type: Number
            },
            duration: {
                type: Number
            }
        },
        methods: {
            
        }
    }
</script>

<style scoped>
.item-wrapper {
    display: flex;
    padding: 0 0.3rem;
    line-height: 1.2rem;
}
.label-wrapper {
    width: 1.5rem;
    font-size: 0.2rem;
}
.label-wrapper div {
    width: 0.7rem;
    height: 0.4rem;
    margin: 0.4rem auto;
    line-height: 0.4rem;
    border-radius: 2px;
    color: #fff;
}
.label-wrapper .live, .label-wrapper .preview {
    background: #ea5504;
}
.label-wrapper .review {
    background: #bababa;
}
.label-wrapper .trail {
    background: #eae204;
    color: #989306;
}
.title {
    flex: 1;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    text-align: left;
    font-size: 0.3rem;
    color: #333333;
}
.status {
    width: 1.2rem;
    height: 1.2rem;
    font-size: 0.25rem;
    color: #666;
}
.status img {
    width: 0.24rem;
    height: 0.27rem;
    margin-top: 0.48rem;
}
.label-wrapper .live {
    width: 1rem;
}
.live span {
    display: inline-block;
    width: 3px;
    margin-left: 2px;
    vertical-align: middle;
    background: #fff;
}
.live .first {
    animation: blink 1.5s infinite;
}
.live .second {
    height: 12px;
    animation: blink 1.5s infinite 0.5s;
}
.live .first, .live .third {
    height: 10px;
}
.live .third {
    margin-right: 4px;
    animation: blink 1.5s infinite 1s;
}
@keyframes blink {
    0% {
        opacity: 1;
    }
    50% {
        opacity: 0;
    }
    100% {
        opacity: 1;
    }
}
</style>